import styled from 'styled-components'
import {Dialog, Typography, Box} from '@mui/material'
import theme from '../../styles/theme'

export const ErrorDialog = styled(Dialog)`
  min-height: 100vh;
  border-radius: 0;
`

export const DialogTitle = styled(Typography)`
  font-size: 20px;
  color: #2d2d2d;
  border-bottom: 0.5px solid #dbdbdb;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  line-height: 27px;

  ${theme.breakpoints.down('xs')} {
    font-size: 16px;
    padding: 0 20px;
  }
`

export const DialogBox = styled(Box)`
  padding: 24px;
  width: 562px;
  overflow-x: hidden;

  ${theme.breakpoints.down('sm')} {
    width: 450px;
  }

  ${theme.breakpoints.down('xs')} {
    width: auto;
    padding: 24px 20px 20px 20px;
  }
`

export const DialogText = styled(Typography)`
  font-size: 16px;
  color: #2d2d2d;

  ${theme.breakpoints.down('xs')} {
    font-size: 14px;
  }
`

export const FormBox = styled(Box)`
  display: flex;
  flex-flow: column;
  gap: 12px;
  margin-top: 24px;
`

export const ButtonBox = styled(Box)<{$isFullWidth: boolean}>`
  display: flex;
  align-items: center;
  margin-top: 24px;
  gap: 16px;

  ${({$isFullWidth}) =>
    $isFullWidth
      ? `
        && button {
          width: 100% !important;
        }
      `
      : null}
`
